import Vue from 'vue'
import Vuex from 'vuex'
import articleImg1En from './assets/article/3-3zh.png'
import articleImg1Zh from './assets/article/3-3en.png'
import articleImg173En from './assets/article/17-3-en.png'
import articleImg173Zh from './assets/article/17-3-zh.jpg'
import articleImg174En from './assets/article/17-4-en.png'
import articleImg174Zh from './assets/article/17-4-zh.png'
import articleImg175En from './assets/article/17-5-en.png'
import articleImg175Zh from './assets/article/17-5-zh.jpg'
import articleImg183En from './assets/article/18-3 RedteaGO App for iPhone eSIM _en.png'
import articleImg183Zh from './assets/article/18-3 RedteaGO App for iPhone eSIM.png'
import articleImg185En from './assets/article/18-5 (RedteaGO Global eSIM Plan) _en.png'
import articleImg185Zh from './assets/article/18-5 (RedteaGO Global eSIM Plan) _zh.png'
import article0Img1En from './assets/article/article0/RedteaSIM_EN02.jpg'
import article0Img2En from './assets/article/article0/RedteaSIM_EN03.jpg'
import article0Img3En from './assets/article/article0/RedteaSIM_EN04.png'
import article0Img1ZH from './assets/article/article0/RedteaSIM_ZH02.jpg'
import article0Img2ZH from './assets/article/article0/RedteaSIM_ZH03.jpg'
import article0Img3ZH from './assets/article/article0/RedteaSIM_ZH04.jpg'

import img1En from './assets/web/Banner_CaaS(EN).png'
import img1Zh from './assets/web/Banner_CaaS(CN).png'
import banner1En from './assets/banner/Banner1.png'
import banner1Zh from './assets/banner/Banner1中文.png'
import banner2En from './assets/banner/Banner2.png'
import banner2Zh from './assets/banner/Banner2中文.png'
import banner3En from './assets/banner/Banner3.png'
import banner3Zh from './assets/banner/Banner3中文.png'
import banner4En from './assets/banner/Banner4英文.png'
import banner4Zh from './assets/banner/Banner4中文.png'
import banner5En from './assets/banner/Banner5英文.png'
import banner5Zh from './assets/banner/Banner5中文.png'
import goImgEn from './assets/go-web/首图英文.png'
import goImgZh from './assets/go-web/首图中文.png'
import simImgEn from './assets/redteaSIM-web/RedteaSIM 首图@2x.png'
import simImgZh from './assets/redteaSIM-web/RedteaSIM 中文首图@2x.png'
import readyImgEn from './assets/ready-web/first-en.png'
import readyImgZh from './assets/ready-web/first-zh.png'
import readyImg1En from './assets/ready-web/earth-en.png'
import readyImg1Zh from './assets/ready-web/earth-zh.png'

import mBanner1En from './assets/banner/1.png'
import mBanner1Zh from './assets/banner/1中文.png'
import mBanner2En from './assets/banner/2.png'
import mBanner2Zh from './assets/banner/2中文.png'
import mBanner3En from './assets/banner/3.png'
import mBanner3Zh from './assets/banner/3中文.png'
import mBanner4En from './assets/banner/banner4  英文 手机.png'
import mBanner4Zh from './assets/banner/banner4 中文 手机.png'
import mBanner5En from './assets/banner/banner5_en_m.png'
import mBanner5Zh from './assets/banner/banner5_zh_m.png'
import CaasEn from './assets/mobile/首图.png'
import CaasZh from './assets/mobile/首图中文.png'
import mreadyImgEn from './assets/ready-mobile/first-en-m.png'
import mreadyImgZh from './assets/ready-mobile/first-zh-m.png'
import mreadyImg1En from './assets/ready-mobile/earth-en-m.png'
import mreadyImg1Zh from './assets/ready-mobile/earth-zh-m.png'
import coverEn from './assets/article/地图英文@2x.png'
import coverZh from './assets/article/地图中文@2x.png'
import msimImgEn from './assets/redteaSIM-mobile/RedteaSIM 首图手机@2x.png'
import msimImgZh from './assets/redteaSIM-mobile/RedteaSIM 首图手机中文.png'
Vue.use(Vuex)

const str = window.localStorage
export default new Vuex.Store({
  state: {
    img1: str.getItem('mobileLang') === 'zh' ? img1Zh : img1En,
    mImg1: str.getItem('mobileLang') === 'zh' ? CaasZh : CaasEn,
    goImg: str.getItem('mobileLang') === 'zh' ? goImgZh : goImgEn,
    simImg: str.getItem('mobileLang') === 'zh' ? simImgZh : simImgEn,
    msimImg: str.getItem('mobileLang') === 'zh' ? msimImgZh : msimImgEn,
    readyImg: str.getItem('mobileLang') === 'zh' ? readyImgZh : readyImgEn,
    readyImg1: str.getItem('mobileLang') === 'zh' ? readyImg1Zh : readyImg1En,
    mreadyImg: str.getItem('mobileLang') === 'zh' ? mreadyImgZh : mreadyImgEn,
    mreadyImg1:
      str.getItem('mobileLang') === 'zh' ? mreadyImg1Zh : mreadyImg1En,
    banner1: str.getItem('mobileLang') === 'zh' ? banner1Zh : banner1En,
    banner2: str.getItem('mobileLang') === 'zh' ? banner2Zh : banner2En,
    banner3: str.getItem('mobileLang') === 'zh' ? banner3Zh : banner3En,
    banner4: str.getItem('mobileLang') === 'zh' ? banner4Zh : banner4En,
    banner5: str.getItem('mobileLang') === 'zh' ? banner5Zh : banner5En,
    mbanner1: str.getItem('mobileLang') === 'zh' ? mBanner1Zh : mBanner1En,
    mbanner2: str.getItem('mobileLang') === 'zh' ? mBanner2Zh : mBanner2En,
    mbanner3: str.getItem('mobileLang') === 'zh' ? mBanner3Zh : mBanner3En,
    mbanner4: str.getItem('mobileLang') === 'zh' ? mBanner4Zh : mBanner4En,
    mbanner5: str.getItem('mobileLang') === 'zh' ? mBanner5Zh : mBanner5En,
    articleImg1:
      str.getItem('mobileLang') === 'zh' ? articleImg1Zh : articleImg1En,
    articleImg173:
      str.getItem('mobileLang') === 'zh' ? articleImg173Zh : articleImg173En,
    articleImg174:
      str.getItem('mobileLang') === 'zh' ? articleImg174Zh : articleImg174En,
    articleImg175:
      str.getItem('mobileLang') === 'zh' ? articleImg175Zh : articleImg175En,
    articleImg185:
      str.getItem('mobileLang') === 'zh' ? articleImg185Zh : articleImg185En,
    articleImg183:
      str.getItem('mobileLang') === 'zh' ? articleImg183Zh : articleImg183En,
    article0Img1:
      str.getItem('mobileLang') === 'zh' ? article0Img1ZH : article0Img1En,
    article0Img2:
      str.getItem('mobileLang') === 'zh' ? article0Img2ZH : article0Img2En,
    article0Img3:
      str.getItem('mobileLang') === 'zh' ? article0Img3ZH : article0Img3En,
    cover: str.getItem('mobileLang') === 'zh' ? coverZh : coverEn,
    localLang: str.getItem('mobileLang') ? str.getItem('mobileLang') : 'en'
  },
  mutations: {
    changeImg(state, locale) {
      state.img1 = locale === 'en' ? img1En : img1Zh
      state.banner1 = locale === 'en' ? banner1En : banner1Zh
      state.banner2 = locale === 'en' ? banner2En : banner2Zh
      state.banner3 = locale === 'en' ? banner3En : banner3Zh
      state.banner4 = locale === 'en' ? banner4En : banner4Zh
      state.banner5 = locale === 'en' ? banner5En : banner5Zh
      state.goImg = locale === 'en' ? goImgEn : goImgZh
      state.simImg = locale === 'en' ? simImgEn : simImgZh
      state.readyImg = locale === 'en' ? readyImgEn : readyImgZh
      state.readyImg1 = locale === 'en' ? readyImg1En : readyImg1Zh
      state.articleImg1 = locale === 'en' ? articleImg1En : articleImg1Zh
      state.articleImg173 = locale === 'en' ? articleImg173En : articleImg173Zh
      state.articleImg174 = locale === 'en' ? articleImg174En : articleImg174Zh
      state.articleImg175 = locale === 'en' ? articleImg175En : articleImg175Zh
      state.articleImg185 = locale === 'en' ? articleImg185En : articleImg185Zh
      ;(state.articleImg183 =
        locale === 'en' ? articleImg183En : articleImg183Zh),
        (state.article0Img1 = locale === 'en' ? article0Img1En : article0Img1ZH)
      state.article0Img2 = locale === 'en' ? article0Img2En : article0Img2ZH
      state.article0Img3 = locale === 'en' ? article0Img3En : article0Img3ZH
      state.cover = locale === 'en' ? coverEn : coverZh
      state.localLang = locale
      str.setItem('img1', state.img1)
      str.setItem('banner1', state.banner1)
      str.setItem('banner2', state.banner2)
      str.setItem('banner3', state.banner3)
      str.setItem('banner4', state.banner4)
      str.setItem('banner5', state.banner5)
      str.setItem('goImg', state.goImg)
      str.setItem('simImg', state.simImg)
      str.setItem('readyImg', state.readyImg)
      str.setItem('readyImg', state.readyImg)
      str.setItem('articleImg1', state.articleImg1)
      str.setItem('articleImg173', state.articleImg173)
      str.setItem('articleImg174', state.articleImg174)
      str.setItem('articleImg175', state.articleImg175)
      str.setItem('articleImg185', state.articleImg185)
      str.setItem('cover', state.cover)
      str.setItem('mobileLang', locale)
    },
    changeMobileImg(state, locale) {
      state.mImg1 = locale === 'en' ? CaasEn : CaasZh
      state.msimImg = locale === 'en' ? msimImgEn : msimImgZh
      state.mbanner1 = locale === 'en' ? mBanner1En : mBanner1Zh
      state.mbanner2 = locale === 'en' ? mBanner2En : mBanner2Zh
      state.mbanner3 = locale === 'en' ? mBanner3En : mBanner3Zh
      state.mbanner4 = locale === 'en' ? mBanner4En : mBanner4Zh
      state.mbanner5 = locale === 'en' ? mBanner5En : mBanner5Zh
      state.mreadyImg = locale === 'en' ? mreadyImgEn : mreadyImgZh
      state.mreadyImg1 = locale === 'en' ? mreadyImg1En : mreadyImg1Zh
      state.articleImg1 = locale === 'en' ? articleImg1En : articleImg1Zh
      state.articleImg173 = locale === 'en' ? articleImg173En : articleImg173Zh
      state.articleImg174 = locale === 'en' ? articleImg174En : articleImg174Zh
      state.articleImg175 = locale === 'en' ? articleImg175En : articleImg175Zh
      state.articleImg185 = locale === 'en' ? articleImg185En : articleImg185Zh
      state.articleImg183 = locale === 'en' ? articleImg183En : articleImg183Zh
      state.cover = locale === 'en' ? coverEn : coverZh
      state.localLang = locale
      str.setItem('mImg1', state.mImg1)
      str.setItem('mbanner1', state.mbanner1)
      str.setItem('mbanner2', state.mbanner2)
      str.setItem('mbanner3', state.mbanner3)
      str.setItem('mbanner4', state.mbanner4)
      str.setItem('mbanner5', state.mbanner5)
      str.setItem('mreadyImg', state.mreadyImg)
      str.setItem('mreadyImg1', state.mreadyImg1)
      str.setItem('msimImg', state.msimImg)
      str.setItem('articleImg1', state.articleImg1)
      str.setItem('articleImg173', state.articleImg173)
      str.setItem('articleImg174', state.articleImg174)
      str.setItem('articleImg175', state.articleImg175)
      str.setItem('articleImg185', state.articleImg185)
      str.setItem('cover', state.cover)
      str.setItem('mobileLang', locale)
    }
  },
  actions: {}
})
